import React from "react";
import "./ServicesPage.css";
import { Link } from "react-router-dom";

const services = [
  {
    title: "הובלת חומרי בניין",
    desc: "הובלה מקצועית של חומרי בניין לאתרי בנייה, קבלנים ולקוחות פרטיים, באמצעות משאיות מתאימות וביצוע בטוח ומדויק בהתאם לתנאי השטח.",
    img: "/7.jpeg",
    path: "/Transportation_of_building_materials",
  },

  {
    title: "הובלות עם מנוף הרמה",
    desc: "הובלה והרמה של ציוד כבד, ריהוט, חומרי בניין ופריטים גדולים באמצעות מנוף הרמה, גם במקומות עם גישה מורכבת או מוגבלת.",
    img: "/6.jpeg",
    path: "/Moving_with_a_lifting_crane",
  },

  {
    title: "שירותי מנוף",
    desc: "שירותי מנוף מקצועיים להרמת ציוד כבד, חומרי בניין, משטחים ופריטים גדולים, עם התאמה לתנאי השטח וביצוע בטוח ומדויק.",
    img: "/5.jpeg",
    path: "/Crane_Rental",
  },

  {
    title: "מנוף סל להרמת אדם",
    desc: "השכרת מנוף סל להרמת אדם לעבודות בגובה, תחזוקה, התקנות וגיזום, עם התאמת המנוף לתנאי השטח ולדרישות העבודה.",
    img: "/10.jpeg",
    path: "/Renting_a_basket_crane_for_lifting_a_person",
  },

  {
    title: "שינוע ציוד כבד",
    desc: "שינוע והובלה מקצועית של מכונות, ציוד תעשייתי ומטענים כבדים, עם התאמה למשקל, למידות ולתנאי הגישה בשטח.",
    img: "/9.jpeg",
    path: "/Transporting_heavy_equipment",
  },

{
  title: "מנוף הרמה בפתח תקווה",
  desc: "שירותי מנוף והרמה בפתח תקווה לעבודות בגובה, הובלת ציוד והרמת מטענים, גם ברחובות צרים ובאתרים עם גישה מורכבת.",
  img: "/8.jpeg",
  path: "/Lifting_crane_in_Petah_Tikva",
},
];

export default function ServicesPage() {
  return (
    <section className="services-page" id="services">

      {/* =====================================================
          HEADER
      ====================================================== */}

      <div className="services-header">

        <span className="services-label">
          ש.מ הובלות ומנופים
        </span>

        <h1 className="page-title">
          השירותים שלנו
        </h1>

        <p className="services-intro">
          פתרונות מקצועיים להובלה, הרמה ושינוע של ציוד ופריטים
          בכל הגדלים, עם התאמה מלאה לכל סוג פרויקט.
        </p>

      </div>


      {/* =====================================================
          SERVICES GRID
      ====================================================== */}

      <div className="services-grid">

        {services.map((item, index) => (

          <Link
            to={item.path}
            key={index}
            className="service-card"
            onClick={() => {
              window.scrollTo({
                top: 0,
                left: 0,
                behavior: "instant",
              });
            }}
          >

            {/* IMAGE */}

            <div className="service-image-wrapper">

              <img
                src={item.img}
                alt={`${item.title} - ש.מ הובלות ומנופים`}
                className="service-image"
                loading="lazy"
              />

              <div className="service-overlay"></div>

              <div className="service-number">
                {String(index + 1).padStart(2, "0")}
              </div>

            </div>


            {/* CONTENT */}

            <div className="service-content">

              <h3>
                {item.title}
              </h3>

              <p>
                {item.desc}
              </p>

              <span className="service-link">
                לפרטים נוספים

                <span className="service-arrow">
                  ←
                </span>
              </span>

            </div>

          </Link>

        ))}

      </div>

    </section>
  );
}
